import filterData from "./src/filterData";

function FilterHeader({ activeFilter, processActiveFilter }) {
  return (
    <div className="notifs-extra-filters">
      {/* <span className="filter-title">Filtro sipas:</span> */}
      {filterData.map((el, idx) => (
        <span
          className="filter-btn"
          key={idx}
          onClick={() => processActiveFilter(el.id)}
        >
          {<el.Icon fill={el.id === activeFilter ? el.color2 : el.color} />}
          {el.title}
        </span>
      ))}
    </div>
  );
}

export default FilterHeader;
